<template>
<w-sliding-popup type="setting" ref="slidingPopup" title="장비 리스트" @close="close" width="700px" >
  <div slot="content">
    <el-row class="title-bar" type="flex" justify="end">
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-table-wrapper slot="body" v-loading="isLoading" ref="deviceListTable" :data="tableData" :columns="tableColumns"
    :column-default="columnDefault" @condition-change="onTableConditionChange" :total="total" remote pagination
    :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;">
    </el-table-wrapper>
  </div>
</w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';

export default {
  name: 'WSetModelOidPopup',
  data() {
    return {
      isLoading: false,
      columnDefault,
      total: null,
      tableData: null,
      showSearchTool: false,
      tableColumns: [
        {
          prop: 'objName',
          label: '장비 명',
          remoteProp: 'o.obj_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          remoteProp: 'IF(o.ipaddress_applytype = "IPv4", ipaddress_ipv4, ipaddress_ipv6)',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objtypeName',
          label: '장비 종류',
          remoteProp: 'ot.objtype_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objProductId',
          label: '모델 명',
          remoteProp: 'o.obj_product_id',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  methods: {
    open(row) {
      this.$refs.slidingPopup.open();
      this.objOid = row.objOid;
      this.loadData();
    },
    close() {
      this.tableData = [];
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    loadData() {
      this.$nextTick(() => {
        this.isLoading = true;
        const tableParams = this.$refs.deviceListTable.getParameter();
        const params = {
          managetypeId: 'NMS',
          objOid: this.objOid,
          ...tableParams,
        };
        NetdeviceSettingAPI.getObjListByObjOid(params).then((result) => {
          if (result.data.success) {
            this.tableData = result.data.data;
            this.total = result.data.total;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장비 리스트', result.data.success));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장비 리스트', false));
        }).finally(() => {
          this.isLoading = false;
        });
      });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    onTableConditionChange() {
      this.loadData();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/VendorModelOidSettings/component/ModelOidSettingView/popup/DeviceListPopup.vue